import { Template } from '@/content/templates/template.types';

export const JSM_TEMPLATES_CONTENT: Template[] = [
	{
		templateId: 'it-service-management',
		name: 'IT service management',
		oneLinerHeadline: 'Intake requests, set up alerts, raise incidents, and fix issues quickly.',
		urlSlug: 'it-service-management',
		templateIcon: {
			name: 'Jira roadmap',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/ug362u6qv3ywnwcca17012vsdfpwcu1j.svg',
			description: 'Jira roadmap',
		},
		keyFeatures: [
			{
				name: 'Alerts and on-call schedules',
				iconRef: 'alert-icon',
			},
			{
				name: 'Multi-channel support',
				iconRef: 'headphone-icon',
			},
		],
	},
	{
		templateId: 'advanced-it-service-management',
		name: 'Advanced IT service management',
		oneLinerHeadline: 'Incident, change, and problem management with ITSM best practices.',
		urlSlug: 'advanced-it-service-management',
		templateIcon: {
			name: 'Help Center screenshot',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/3fte56b800hsu0n8r76727ht510v7808.svg',
			description: 'Help Center screenshot',
		},
		keyFeatures: [
			{
				name: 'Automated change requests',
				iconRef: 'check-task-icon',
			},
			{
				name: 'Alerts and on-call schedules',
				iconRef: 'alert-icon',
			},
		],
	},
	{
		templateId: 'hr-service-management',
		name: 'HR service management',
		oneLinerHeadline: 'Manage onboarding and offboarding and respond to HR requests.',
		urlSlug: 'hr-service-management',
		templateIcon: {
			name: 'Jira roadmap',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/cre6xx6lyq1hcp327v813e1t38k241sx.svg',
			description: 'Jira roadmap',
		},
		keyFeatures: [
			{
				name: 'Self-service and FAQ help center',
				iconRef: 'help-icon',
			},
			{
				name: 'Customizable request forms',
				iconRef: 'mail-icon',
			},
		],
	},
	{
		templateId: 'customer-service-management',
		name: 'Customer service management',
		oneLinerHeadline: 'Deliver great service experiences for your external customers.',
		urlSlug: 'customer-service-management',
		templateIcon: {
			name: 'Jira roadmap',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/2b83vv62ssm4g2km1m7638d126w2e1u3.svg',
			description: 'Jira roadmap',
		},
		keyFeatures: [
			{
				name: 'Developer escalations',
				iconRef: 'flag-icon',
			},
			{
				name: 'Self-service and FAQ help center',
				iconRef: 'help-icon',
			},
		],
	},
	{
		templateId: 'marketing-service-management',
		name: 'Marketing service management',
		oneLinerHeadline: 'Manage and track all your marketing requests.',
		urlSlug: 'marketing-service-management',
		templateIcon: {
			name: 'Jira roadmap',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/g13dr33528x350811shfr52mr5y5hr72.svg',
			description: 'Jira roadmap',
		},
		keyFeatures: [
			{
				name: 'Forms for Marketing requests',
				iconRef: 'mail-icon',
			},
			{
				name: 'Reports',
				iconRef: 'data-points-icon',
			},
		],
	},
	{
		templateId: 'design-service-management',
		name: 'Design service management',
		oneLinerHeadline: 'Manage and track all your design requests.',
		urlSlug: 'design-service-management',
		templateIcon: {
			name: 'Help Center screenshot',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/e4tgp6i7841gcfb7wf43k0j6a2576264.svg',
			description: 'Help Center screenshot',
		},
		keyFeatures: [
			{
				name: 'Self-service and FAQ help center',
				iconRef: 'help-icon',
			},
			{
				name: 'Automated design workflows',
				iconRef: 'workflow-icon',
			},
		],
	},
	{
		templateId: 'finance-service-management',
		name: 'Finance service management',
		oneLinerHeadline: 'Manage and track budget, spend, and other finance requests.',
		urlSlug: 'finance-service-management',
		templateIcon: {
			name: 'Form view',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/401876mvht4ti1a070a3s3o3t3i6s51u.svg',
			description: 'Form view',
		},
		keyFeatures: [
			{
				name: 'Forms for Finance requests',
				iconRef: 'mail-icon',
			},
			{
				name: 'Reporting and tracking',
				iconRef: 'data-points-icon',
			},
		],
	},
	{
		templateId: 'analytics-service-management',
		name: 'Analytics service management',
		oneLinerHeadline: 'Manage employee requests for the data and insights they need.',
		urlSlug: 'analytics-service-management',
		templateIcon: {
			name: 'Jira roadmap',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/hqvjo4k71u4x3y6e2nkden08471f4e47.svg',
			description: 'Jira roadmap',
		},
		keyFeatures: [
			{
				name: 'Self-service and FAQ help center',
				iconRef: 'help-icon',
			},
			{
				name: 'Automated Analytics workflows',
				iconRef: 'robot-icon',
			},
		],
	},
	{
		templateId: 'facilities-service-management',
		name: 'Facilities service management',
		oneLinerHeadline: 'Manage requests for maintenance, moving, and event planning.',
		urlSlug: 'facilities-service-management',
		templateIcon: {
			name: 'Help center screenshot',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/18xqw35pw8do7ru0wp3d8oscs2fmw1mf.svg',
			description: 'Help center screenshot',
		},
		keyFeatures: [
			{
				name: 'Forms for Facilities requests',
				iconRef: 'mail-icon',
			},
			{
				name: 'Self-service and FAQ help center',
				iconRef: 'help-icon',
			},
		],
	},
	{
		templateId: 'sales-service-management',
		name: 'Sales service management',
		oneLinerHeadline: 'Manage, track, and report on all your sales requests.',
		urlSlug: 'sales-service-management',
		templateIcon: {
			name: 'Kanban board',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/1k3k7o8j66265rdk5e6vj0o23g611j04.svg',
			description: 'Kanban board',
		},
		keyFeatures: [
			{
				name: 'Forms designed for Sales requests',
				iconRef: 'mail-icon',
			},
			{
				name: 'Reporting and tracking',
				iconRef: 'data-points-icon',
			},
		],
	},
	{
		templateId: 'legal-service-management',
		name: 'Legal service management',
		oneLinerHeadline: 'Manage and track all your contracts and legal requests.',
		urlSlug: 'legal-service-management',
		templateIcon: {
			name: 'Jira roadmap',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/47k1ynn8f0024m4tg2vd6omf3jr60h7u.svg',
			description: 'Jira roadmap',
		},
		keyFeatures: [
			{
				name: 'Self-service and FAQ help center',
				iconRef: 'help-icon',
			},
			{
				name: 'Customer portal to take requests',
				iconRef: 'mail-icon',
			},
		],
	},
	{
		templateId: 'general-service-management',
		name: 'General service management',
		oneLinerHeadline: 'Collect, prioritize, and manage requests for any business teams.',
		urlSlug: 'general-service-management',
		templateIcon: {
			name: 'Queues view',
			size: 200,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319',
			refreshUrl:
				'https://dam-cdn.atl.orangelogic.com/AssetLink/2x43564ibsn386dk7g764353rk2341n2.svg',
			description: 'Queues view',
		},
		keyFeatures: [
			{
				name: 'Self-service and FAQ help center',
				iconRef: 'help-icon',
			},
			{
				name: 'Customer portal to take requests',
				iconRef: 'mail-icon',
			},
		],
	},
];
